import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../lib/axios";
import clientslogo1 from "../../Assets/Indorinama-website-elements/Icons/clients.svg";

export const ClientSection = () => {
  const [clientslogo, setClientslogo] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const page = useLocation().pathname.split("/")[1];
  const [allLogos, setAllLogos] = useState({});

  const getLogoURL = (logo) =>
    logo?.logo?.cloudinary?.secure_url || logo?.logo?.url || "";

  const getClientLogosKey = (currentPage) => {
    switch (currentPage) {
      case "radio":
      case "radio-advertising":
        return "radio_client_logos";
      case "cinema":
      case "cinema-advertising":
        return "cinema_client_logos";
      case "transit":
      case "transit-advertising":
        return "transit_client_logos";
      case "outdoor":
      case "outdoor-advertising":
        return "outdoor_client_logos";
      case "non-traditional":
      case "non-traditional-advertising":
        return "non_traditional_client_logos";
      case "btl":
      case "btl-advertising":
        return "btl_client_logos";
      case "digital":
      case "digital-advertising":
        return "digital_client_logos";
      case "influencer-marketing":
        return "influencer_client_logos";
      case "newspaper":
      case "newspaper-advertising":
        return "newsletter_client_logos";
      case "designing":
        return "design_client_logos";
      case "printing":
        return "printing_client_logos";
      case "brand-endorsement":
        return "brand_endorsement_client_logos";
      case "advertising":
      default:
        return "client_logos";
    }
  };

  useEffect(() => {
    const getLogos = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const response = await axios.get("/api/globals/clients");

        setAllLogos(response.data);
        setClientslogo([]);
      } catch (fetchError) {
        console.error("Error fetching client logos:", fetchError);
        setError(fetchError.message);
      } finally {
        setIsLoading(false);
      }
    };

    getLogos();
  }, []);

  useEffect(() => {
    const key = getClientLogosKey(page);

    if (allLogos[key]) {
      const sortedLogos = [...allLogos[key]].sort(
        (a, b) => a.sort_order - b.sort_order,
      );
      setClientslogo([...sortedLogos]);
    }
  }, [page, allLogos]);

  const doubledLogos = React.useMemo(
    () => clientslogo.concat(clientslogo),
    [clientslogo],
  );

  if (error) {
    return (
      <div className="flex justify-center items-center py-8">
        <p className="text-red-500">
          Failed to load client logos. Please try again later.
        </p>
      </div>
    );
  }

  return (
    <section className="cl-sec bg-transparent py-12 overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="cl-head flex justify-center mb-12">
          <img
            src={clientslogo1}
            alt="Our Clients"
            className="max-md:h-[3.75rem] h-16 md:h-20 w-auto"
          />
        </div>

        {isLoading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-pulse flex space-x-4">
              <div className="h-12 w-12 bg-gray-200 rounded-full"></div>
              <div className="h-12 w-12 bg-gray-200 rounded-full"></div>
              <div className="h-12 w-12 bg-gray-200 rounded-full"></div>
            </div>
          </div>
        ) : (
          <div className="relative w-full">
            <div className="flex overflow-hidden">
              <div className="flex animate-scroll">
                {doubledLogos?.map((logo, index) => (
                  <div
                    key={`${index}`}
                    className="mx-3 flex-shrink-0 sm:mx-4"
                  >
                    <div className="flex h-[80px] w-[150px] items-center justify-center rounded-2xl border border-black/5 bg-white px-4 shadow-sm sm:h-[96px] sm:w-[180px] sm:px-5">
                      <img
                        className="max-h-[50px] w-full object-contain sm:max-h-[62px]"
                        src={getLogoURL(logo)}
                        alt={`Client logo ${index + 1}`}
                        loading="lazy"
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-scroll {
          animation: scroll 20s linear infinite;
        }
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};
